import React, { useState } from 'react';
import { NavLink} from 'react-router-dom';
import { useAuth } from '../AuthContext';

export default function Login() {

    const apiKey = process.env.REACT_APP_API_KEY;
    const baseURL = process.env.REACT_APP_BASE_URL;
    const [isUsernameValid, setIsUsernameValid] = useState(true);
    const [isPasswordValid, setIsPasswordValid] = useState(true);
    const { login } = useAuth();
   
    const [formData, setFormData] = useState({
        password: '',
        username: '',
    });

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });

        if (name === 'username') {
            setIsUsernameValid(value.length >= 5);
        }
        if (name === 'password') {
            setIsPasswordValid(value.length >= 8);
        }
    };
    const [showPassword, setShowPassword] = useState(false);
    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };



    const handleLogin = async (e) => {
        e.preventDefault();

        if (!isUsernameValid) {
            alert('Username should be at least 5 characters long.');
            return;
        }
        if (!isPasswordValid) {
            alert('Password should be at least 8 characters long.');
            return;
        }

        try {
            const response = await fetch(`${baseURL}/createaccount/`, {
                method: 'POST',
                headers: {
                    'accept': 'application/json',
                    'Authorization': apiKey,
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({


                    userid: "string",
                    identifier: formData.username,
                    account_type: 5,
                    password: formData.password,
                    email: "string",
                    username: formData.username,
                    name: "string",
                    photo: "string",
                    genderid: 0,
                    phonenumber: "string",
                    uid: "string",
                    appversion: "string",
                    androidid: "string",
                    stateid: 0,
                    districtid: 0,
                    zipcode: "string",
                    udise: "string",
                    school_name: "string",
                    login: true


                }),
            });


            const result = await response.json();

            if (response.ok) {


                const extractedUserId = result[0].userid;

                localStorage.setItem('authToken', apiKey);
                localStorage.setItem('userid', extractedUserId);

                login();
               
                window.location.href = "/home";

               


            } else {
                alert(`login Failed `);
            }
        } catch (error) {
            alert(`Please enter correct username and password`);
        }
    };




    return (
        <>
            <section className="user-form-part">
                <div className="container">
                    <div className="row justify-content-center">
                        <div className="col-12 col-sm-10 col-md-6 col-lg-5 col-xl-4">

                            <div className="user-form-card">
                                <div className="user-form-title">
                                    <h2>Welcome</h2>
                                    <p>Enter your credentials to access your account</p>
                                </div>
                                <div className="user-form-group">
                                    <form onSubmit={handleLogin} className="user-form">

                                        <div className="form-group">
                                            <input type="text" className="form-control" name="username"  onChange={handleChange} placeholder='Enter User Name' required autoComplete="current-password" />
                                        </div>

                                        <div className="form-group">
                                            <input type={showPassword ? 'text' : 'password'} id="password" name="password" className="form-control"  onChange={handleChange} placeholder='Enter Password' required autoComplete="current-password" />
                                            <span toggle="#password" className={`far fa-fw ${showPassword ? 'fa-eye' : 'fa-eye-slash'} eye-icon toggle-password`} onClick={togglePasswordVisibility}></span>
                                        </div>



                                        <div className="form-button">
                                            <button type="submit" >sign in</button>
                                        </div>
                                    </form>

                                </div>
                            </div>
                            <div className="user-form-remind">
                                <p>Don't have any account?<NavLink to="/">create a new account</NavLink></p>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}
